/* eslint-disable no-param-reassign */

import Vapi from 'vuex-rest-api';

const admin = new Vapi({
  state: {
    spawnerAdminGlobalCounts: {
      // Custom Log Levels
      site: 0,
      server: 0,
    },
  },
})
  .get({
    action: 'getSpawnerAdminGlobalCounts',
    path: () => '/api/spawner/admin/globalCounts',
    property: 'spawnerAdminGlobalCounts',
  })
  .getStore();

const mutations = {
  updateSpawnerGlobalCount: (state, payload) => {
    console.log(payload);
    state.spawnerAdminGlobalCounts[payload.model] = payload.count;
  },
  updateSpawnerGlobalCounts: (state, payload) => {
    // console.log(payload);
    state.spawnerAdminGlobalCounts = payload;
  },
};

const actions = {
  updateSpawnerGlobalCount({ commit }, payload) {
    commit('updateSpawnerGlobalCount', payload);
  },
  updateSpawnerGlobalCounts({ commit }, payload) {
    commit('updateSpawnerGlobalCounts', payload);
  },
};

admin.mutations = Object.assign(admin.mutations, mutations);
admin.actions = Object.assign(admin.actions, actions);

export default admin;
